import Img2019_1 from '../img/jury/2019_1.jpg'
import Img2019_2 from '../img/jury/2019_2.jpg'
import Img2019_3 from '../img/jury/2019_3.jpg'
import Img2020_1 from '../img/jury/2020_1.jpg'
import Img2020_2 from '../img/jury/2020_2.jpg'
import Img2020_3 from '../img/jury/2020_3.jpg'
import Img2021_1 from '../img/jury/2021_1.jpg'

const data = [
    {
      year: 2019,
      items: [
        {
          name: 'ВЯЧЕСЛАВ ДЮДЕНКО',
          country: 'Украина',
          image: Img2019_1,
          text1: 'Председатель правления КССК',
          text2: 'Командор Ордена Шевалье',
          text3: 'Профессор по научно-прикладному направлению "Культура и искусство в области высоких технологий моделирования имидж-дизайна"',
          text4: 'Судья международного класса',
          text5: 'Фешн-директор школы профессионального мастерства парикмахеров "Дюденко Киев"',
          text6: 'Владелец сети салонов "D2"',
        },
        {
            name: 'КРИСТИНА КРУГЛОВА',
            country: 'Беларусь',
          image: Img2019_2,
          text1: 'Двукратный серебряный призер Беларуси в технической категории',
          text2: 'Многократный призер и победитель фестиваля красоты «Невские берега», Санкт-Петербург, Россия',
          text3: 'Победитель фестиваля «Мир красоты», Беларусь Сертифицированный судья и тренер',
          text4: 'Призер и победитель Международного фестиваля красоты «Золотой подснежник», Беларусь',
          text5: 'Победитель Международного конкурса Mon Platin',
          text6: 'Стилист Wedding Fashion week ',
        },
        {
            name: 'ЕЛЕНА ХАСИНЕВИЧ',
            country: 'Беларусь',
          image: Img2019_3,
          text1: 'Сертифицированный судья, спикер международных выставок',
          text2: ' Многократный победитель международных чемпионатов',
          text3: 'Тренер, разработчик авторских программ',
          text4: 'Организатор fashion-показов',
          text5: 'Основатель Гостиных красоты "Шуры-Муры"',
          text6: 'Стилист проекта Miss Super National',
        },
      ],
    },
    {
        year: 2020,
        items: [
          {
            name: 'ЕЛЕНА ГЛАЗКОВА',
            country: 'Украина',
            image: Img2020_1,
            text1: 'Свадебный стилист, художник-модельер парикмахерских работ',
            text2: 'Международный инструктор-преподаватель KODI PROFESSIONAL по направлению "Парикмахерское искусство"',
            text3: 'Член судейской коллегии на Чемпионате Украины',
            text4: 'Тренер объединённой команды Украины для Международных Олимпийских соревнований "Невские берега" (Россия)',
            text5: 'Парикмахер-стилист альтернативной сборной Украины на Чемпионате мира (Франция, 2017 г.)',
            text6: 'Опыт работы в области парикмахерского искусства более 30 лет',
          },
          {
            name: 'СЕРГЕЙ ЗИМА',
            country: 'Украина',
            image: Img2020_2,
            text1: 'Топ-стилист, мастер международного класса',
            text2: 'Член сборной Украины по парикмахерскому искусству',
            text3: 'Чемпион Украины, двукратный призёр чемпионатов мира (Франкфурт, 2014г. и Сеул, 2016г.)',
            text4: 'Сертифицированный судья бьюти-чемпионатов',
            text5: 'Парикмахер-стилист альтернативной сборной Украины на Чемпионате мира',
            text6: 'Опыт работы в области парикмахерского искусства более 15 лет',
          },
          {
            name: 'ОЛЬГА ГЛУШЕНКОВА',
            country: 'Украина',
            image: Img2020_3,
            text1: 'Международный мастер, инструктор-преподаватель, технолог KODI PROFESSIONAL',
            text2: 'Опыт работы в области перманентного макияжа и визажа более 13 лет',
            text3: 'Дипломированный имиджмейкер (Академия Константина Богомолова',
            text4: 'Бронзовый призер чемпионата Украины по стилю и визажу (2009-2010 г.г.)',
            text5: 'Активное развитие преподавательской деятельности с 2007 года',
            text6: 'Стажировка в школе Аtelier (Париж, 2006 г.)',
          },
        ],
      },
      {
        year: 2021,
        items: [
          {
            name: 'КРИСТИНА КРУГЛОВА',
            country: 'Беларусь',
          image: Img2019_2,
          text1: 'Двукратный серебряный призер Беларуси в технической категории',
          text2: 'Многократный призер и победитель фестиваля красоты «Невские берега», Санкт-Петербург, Россия',
          text3: 'Победитель фестиваля «Мир красоты», Беларусь Сертифицированный судья и тренер',
          text4: 'Призер и победитель Международного фестиваля красоты «Золотой подснежник», Беларусь',
          text5: 'Победитель Международного конкурса Mon Platin',
          text6: 'Стилист Wedding Fashion week ',
        },
          {
            name: 'СЕРГЕЙ ЗИМА',
            country: 'Украина',
            image: Img2020_2,
            text1: 'Топ-стилист, мастер международного класса',
            text2: 'Член сборной Украины по парикмахерскому искусству',
            text3: 'Чемпион Украины, двукратный призёр чемпионатов мира (Франкфурт, 2014г. и Сеул, 2016г.)',
            text4: 'Сертифицированный судья бьюти-чемпионатов',
            text5: 'Парикмахер-стилист альтернативной сборной Украины на Чемпионате мира',
            text6: 'Опыт работы в области парикмахерского искусства более 15 лет',
          },
          {
            name: 'ДЕНИС КАРТАШЕВ',
            country: 'Россия',
            image: Img2021_1,
            text1: 'Визажист, чемпион России и Европы по макияжу',
            text2: 'Судья профессиональных конкурсов по визажу OMC, IMATS (London, UK)',
            text3: 'Спикер международной выставки IMATS (London, UK), спикер международной выставки the MAKE UP SHOW (New York, USA)',
            text4: 'Сотрудничество с New York Fashion Week  (New Tork, USA)',
            text5: 'Основатель, креативный директор академии макияжа DENIS KARTASHEV MAKEUP ACADEMY (Moscow, Russia)',
            text6: 'Обладатель Grand Prix International Mondal Coiffure Beaute (Paris, France)',
          },
        ],
      },
      {
        year: 2022,
        items: [
          {
            name: 'ВЯЧЕСЛАВ ДЮДЕНКО',
            country: 'Украина',
            image: Img2019_1,
            text1: 'Председатель правления КССК',
            text2: 'Командор Ордена Шевалье',
            text3: 'Профессор по научно-прикладному направлению "Культура и искусство в области высоких технологий моделирования имидж-дизайна"',
            text4: 'Судья международного класса',
            text5: 'Фешн-директор школы профессионального мастерства парикмахеров "Дюденко Киев"',
            text6: 'Владелец сети салонов "D2"',
          },
          {
            name: 'ЕЛЕНА ГЛАЗКОВА',
            country: 'Украина',
            image: Img2020_1,
            text1: 'Свадебный стилист, художник-модельер парикмахерских работ',
            text2: 'Международный инструктор-преподаватель KODI PROFESSIONAL по направлению "Парикмахерское искусство"',
            text3: 'Член судейской коллегии на Чемпионате Украины',
            text4: 'Тренер объединённой команды Украины для Международных Олимпийских соревнований "Невские берега" (Россия)',
            text5: 'Парикмахер-стилист альтернативной сборной Украины на Чемпионате мира (Франция, 2017 г.)',
            text6: 'Опыт работы в области парикмахерского искусства более 30 лет',
          },
          {
            name: 'ОЛЬГА ГЛУШЕНКОВА',
            country: 'Украина',
            image: Img2020_3,
            text1: 'Международный мастер, инструктор-преподаватель, технолог KODI PROFESSIONAL',
            text2: 'Опыт работы в области перманентного макияжа и визажа более 13 лет',
            text3: 'Дипломированный имиджмейкер (Академия Константина Богомолова',
            text4: 'Бронзовый призер чемпионата Украины по стилю и визажу (2009-2010 г.г.)',
            text5: 'Активное развитие преподавательской деятельности с 2007 года',
            text6: 'Стажировка в школе Аtelier (Париж, 2006 г.)',
          },
        ],
      },
      {
        year: 2023,
        items: [
          {
            name: 'ЕЛЕНА ХАСИНЕВИЧ',
            country: 'Беларусь',
          image: Img2019_3,
          text1: 'Сертифицированный судья, спикер международных выставок',
          text2: ' Многократный победитель международных чемпионатов',
          text3: 'Тренер, разработчик авторских программ',
          text4: 'Организатор fashion-показов',
          text5: 'Основатель Гостиных красоты "Шуры-Муры"',
          text6: 'Стилист проекта Miss Super National',
          },
          {
            name: 'СЕРГЕЙ ЗИМА',
            country: 'Украина',
            image: Img2020_2,
            text1: 'Топ-стилист, мастер международного класса',
            text2: 'Член сборной Украины по парикмахерскому искусству',
            text3: 'Чемпион Украины, двукратный призёр чемпионатов мира (Франкфурт, 2014г. и Сеул, 2016г.)',
            text4: 'Сертифицированный судья бьюти-чемпионатов',
            text5: 'Парикмахер-стилист альтернативной сборной Украины на Чемпионате мира',
            text6: 'Опыт работы в области парикмахерского искусства более 15 лет',
          },
          {
            name: 'ДЕНИС КАРТАШЕВ',
            country: 'Россия',
            image: Img2021_1,
            text1: 'Визажист, чемпион России и Европы по макияжу',
            text2: 'Судья профессиональных конкурсов по визажу OMC, IMATS (London, UK)',
            text3: 'Спикер международной выставки IMATS (London, UK), спикер международной выставки the MAKE UP SHOW (New York, USA)',
            text4: 'Сотрудничество с New York Fashion Week  (New Tork, USA)',
            text5: 'Основатель, креативный директор академии макияжа DENIS KARTASHEV MAKEUP ACADEMY (Moscow, Russia)',
            text6: 'Обладатель Grand Prix International Mondal Coiffure Beaute (Paris, France)',
          },
        ],
      },
  ];

  export default data;
